// extracted by mini-css-extract-plugin
export default {"search":"SegmentForm_search__gXS-D","root":"SegmentForm_root__o0TjO","remove-button":"SegmentForm_remove-button__xmvdK","action-cell":"SegmentForm_action-cell__5l-f1"};